import $axios from '../config.js'
import { url } from '../api_urls/conceptCollections.js'
// import {
//   _upload
// } from '../request.js'

// 获取列表数据
// export function getSwiperListData (params) {
//   console.log(url.list)
//   return $axios.post(url.list, params)
// }
export function getNewConceptListData (params) {
  return $axios.post(url.newConcept, params)
}
export function getHitConceptListData (params) {
  return $axios.post(url.hitConcept, params)
}
// 获取detail列表数据
export function getDetailListData (params) {
  return $axios.post(url.detail, params)
}
// 获取top10trade列表数据
export function getTopTradeListData (params) {
  return $axios.post(url.topTrade, params)
}
// 获取topFormulation列表数据
export function getTopFormulationListData (params) {
  return $axios.post(url.topFormulation, params)
}
// 获取tabList列表数据
export function getTabListData (params) {
  return $axios.post(url.tabList, params)
}
// 获取concept search列表数据
export function getSearchListData (params) {
  return $axios.post(url.search, params)
}
// 获取页面顶部信息
export function getLastUpdateTime (params) {
  return $axios.post(url.getLastUpdateTime, params)
}
// 获取HighLight
export function getHighLight (params) {
  return $axios.post(url.getHighLight, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/conceptCollections.js